var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import AnimateHeight from 'react-animate-height';
import { tokens } from '@servicetitan/tokens/core';
export const Collapsible = React.forwardRef((_a, ref) => {
    var { animate, children, className, el: CollapsibleElement = 'div', easing = tokens.easingStandard, open = false } = _a, props = __rest(_a, ["animate", "children", "className", "el", "easing", "open"]);
    const CollapsibleClasses = classnames('Collapsible', className, {
        'Collapsible--hidden': !open,
        'Collapsible--animated': animate,
    });
    const animateHeightProps = {
        animateOpacity: true,
        duration: parseInt(tokens.durationSlow, 10),
        easing,
        height: open ? 'auto' : 0,
    };
    return (React.createElement(CollapsibleElement, Object.assign({ className: CollapsibleClasses, "data-anvil-component": "Collapsible", ref: ref }, props), animate ? (React.createElement(AnimateHeight, Object.assign({}, animateHeightProps), children)) : (children)));
});
//# sourceMappingURL=Collapsible.js.map